import React from "react";
import LegalPage from "./Legal";

const DATA = {
  tr: {
    title: "Kullanım Koşulları",
    updated: "Son güncelleme: Haziran 2026",
    intro:
      "Bu Kullanım Koşulları, adalcrea.com web sitesini kullanımınıza ilişkin kuralları düzenler. Web sitesini ziyaret ederek veya kullanarak bu koşulları kabul etmiş sayılırsınız.",
    sections: [
      {
        heading: "Genel Hükümler",
        body: [
          "Web sitesi ve içeriği AdalCrea tarafından işletilmektedir. Bu koşulları kabul etmiyorsanız lütfen web sitesini kullanmayınız. AdalCrea, bu koşulları önceden bildirimde bulunmaksızın güncelleme hakkını saklı tutar.",
        ],
      },
      {
        heading: "Fikri Mülkiyet Hakları",
        body: [
          "Web sitesinde yer alan tüm metin, görsel, logo, marka, tasarım ve yazılımlar AdalCrea'ya veya lisans verenlerine aittir ve ilgili mevzuat kapsamında korunmaktadır. Bu içerikler, AdalCrea'nın yazılı izni olmaksızın kopyalanamaz, çoğaltılamaz veya ticari amaçla kullanılamaz.",
        ],
      },
      {
        heading: "Kullanım Kuralları",
        body: ["Web sitesini kullanırken aşağıdaki kurallara uymayı kabul edersiniz:"],
        list: [
          "Web sitesini yasa dışı veya yetkisiz amaçlarla kullanmamak.",
          "Web sitesinin güvenliğini veya işleyişini tehlikeye atacak eylemlerde bulunmamak.",
          "İletişim formları aracılığıyla doğru ve güncel bilgiler paylaşmak.",
          "Başka kişi veya kurumların haklarını ihlal edecek içerik iletmemek.",
        ],
      },
      {
        heading: "Hizmet İçeriği",
        body: [
          "Web sitesinde sunulan bilgiler genel bilgilendirme amaçlıdır ve herhangi bir taahhüt niteliği taşımaz. Sunulan hizmetlerin kapsamı, teklif ve sözleşme aşamasında karşılıklı olarak belirlenir.",
        ],
      },
      {
        heading: "Sorumluluğun Sınırlandırılması",
        body: [
          "AdalCrea, web sitesindeki bilgilerin doğruluğu ve güncelliği için makul çaba gösterir; ancak içeriğin kesintisiz veya hatasız olacağını garanti etmez. Web sitesinin kullanımından doğabilecek dolaylı zararlardan AdalCrea sorumlu tutulamaz.",
        ],
      },
      {
        heading: "Üçüncü Taraf Bağlantıları",
        body: [
          "Web sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu sitelerin içeriğinden veya gizlilik uygulamalarından AdalCrea sorumlu değildir.",
        ],
      },
      {
        heading: "Uygulanacak Hukuk",
        body: [
          "Bu Kullanım Koşulları Türkiye Cumhuriyeti kanunlarına tabidir. Doğabilecek uyuşmazlıklarda İstanbul (Bakırköy) mahkemeleri ve icra daireleri yetkilidir.",
        ],
      },
    ],
    contactNote:
      "Kullanım Koşulları ile ilgili sorularınız için info@adalcrea.com.tr adresinden veya 0543 804 70 05 numaralı telefondan bize ulaşabilirsiniz.",
  },
  en: {
    title: "Terms of Use",
    updated: "Last updated: June 2026",
    intro:
      "These Terms of Use govern your use of the adalcrea.com website. By visiting or using the website, you are deemed to have accepted these terms.",
    sections: [
      {
        heading: "General Provisions",
        body: [
          "The website and its content are operated by AdalCrea. If you do not accept these terms, please do not use the website. AdalCrea reserves the right to update these terms without prior notice.",
        ],
      },
      {
        heading: "Intellectual Property Rights",
        body: [
          "All text, images, logos, trademarks, designs and software on the website belong to AdalCrea or its licensors and are protected under applicable law. This content may not be copied, reproduced or used for commercial purposes without AdalCrea's written permission.",
        ],
      },
      {
        heading: "Rules of Use",
        body: ["When using the website, you agree to comply with the following rules:"],
        list: [
          "Not to use the website for illegal or unauthorized purposes.",
          "Not to take actions that jeopardize the security or operation of the website.",
          "To share accurate and up-to-date information through contact forms.",
          "Not to submit content that violates the rights of other persons or organizations.",
        ],
      },
      {
        heading: "Service Content",
        body: [
          "The information provided on the website is for general informational purposes and does not constitute any commitment. The scope of services is mutually determined during the proposal and contract stages.",
        ],
      },
      {
        heading: "Limitation of Liability",
        body: [
          "AdalCrea makes reasonable efforts to ensure the accuracy and timeliness of the information on the website; however, it does not guarantee that the content will be uninterrupted or error-free. AdalCrea cannot be held liable for any indirect damages arising from the use of the website.",
        ],
      },
      {
        heading: "Third-Party Links",
        body: [
          "Our website may contain links to third-party websites. AdalCrea is not responsible for the content or privacy practices of these sites.",
        ],
      },
      {
        heading: "Governing Law",
        body: [
          "These Terms of Use are governed by the laws of the Republic of Türkiye. The courts and execution offices of Istanbul (Bakırköy) have jurisdiction over any disputes that may arise.",
        ],
      },
    ],
    contactNote:
      "For questions about these Terms of Use, you can reach us at info@adalcrea.com.tr or by calling 0543 804 70 05.",
  },
};

const Terms = () => <LegalPage data={DATA} path="/kullanim-kosullari" />;

export default Terms;
